import { ActionButton, chakraUseBreakpointValue as useBreakpointValue } from "@airhelp/react-ui-components";
import LanguageSwitcherModal from "components/LanguageSwitcher/LanguageSwitcherModal/LanguageSwitcherModal";
import { alternateLanguages } from "config/languages";
import { useLanguage } from "contexts/LocalizationContext";
import type { ModalContextProps } from "contexts/ModalContext";
import { trackEvents } from "utils/trackingUtils";
import type { TrackEventsProps } from "utils/trackingUtils";
import generateFlagKey from "./utils/generateFlagKey";

interface FlagBoxProps {
  openModal: ModalContextProps["openModal"];
  trackingEvents: TrackEventsProps;
}

const FlagBox = ({ openModal, trackingEvents }: FlagBoxProps) => {
  const currentLanguage = useLanguage();
  const modalSize = useBreakpointValue({ base: "full", lg: "xl" });

  const handleClick = () => {
    openModal(<LanguageSwitcherModal />, modalSize);
    trackEvents(trackingEvents);
  };

  if (alternateLanguages[currentLanguage]) return null;

  return <ActionButton flagKey={generateFlagKey(currentLanguage)} handleOnClick={handleClick} />;
};

export default FlagBox;
